export default "/images/f6ce7cdb986fc9af96e6f4bb71dd25d5.avif";